import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteDiameter } from '../Api'

export default generateApiAction({
  baseType: Types.DIAMETERS.DELETE,
  api: deleteDiameter,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/diameters/DeleteAction.js